import {IconButton, Tooltip} from "@material-ui/core";
import React, {FC, useState} from "react";
import CopyIcon from "view/images/CopyIcon";
import crypto from "crypto-js";
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlined";
import {EMAIL_TASK_REVIEW_PATH} from "view/routes";

type ClipboardButtonProps = {
  showId?: string;
  taskId?: string;
  companyId?: string;
  standId?: string;
  email?: string;
};
const renderIcon = <CopyIcon />;

const ClipboardButton: FC<ClipboardButtonProps> = ({
  showId,
  taskId,
  companyId,
  standId,
  email,
}) => {
  const [icon, setIcon] = useState(renderIcon);

  const reviewerKey = import.meta.env.VITE_EMAIL_SALT;
  let text =
    email && reviewerKey
      ? crypto.AES.encrypt(email, reviewerKey).toString()
      : false;
  const encodedEmail = encodeURIComponent(text);
  // With no `key`, the reviewer lands on the `ResendEmailWithKey` recovery modal.
  const link = `${window.origin}${EMAIL_TASK_REVIEW_PATH}?showId=${showId}&taskId=${taskId}&companyId=${companyId}&standId=${standId}&reviewer=${encodedEmail}`;

  const onClick = () => {
    navigator.clipboard.writeText(link);
    setIcon(<CheckCircleOutlinedIcon color="primary" />);
    setTimeout(() => {
      setIcon(renderIcon);
    }, 3000);
  };
  return (
    <Tooltip title="Copy link">
      <IconButton onClick={onClick}>{icon}</IconButton>
    </Tooltip>
  );
};

export default ClipboardButton;
